export function getErrorMessage(error: any): string {
  if (error?.response?.data) {
    const data = error.response.data;

    if (typeof data === 'string') {
      return data;
    } else if (data.message) {
      return data.message;
    } else if (
      data.error &&
      (data.error.message || data.error.error_description)
    ) {
      // 🎯 Muchas APIs encapsulan el mensaje dentro de data.error
      return data.error.message || data.error.error_description;
    } else if (data.errors && typeof data.errors === 'object') {
      return Object.entries(data.errors)
        .map(
          ([field, messages]) =>
            `${field}: ${(messages as string[]).join(', ')}`
        )
        .join('\n');
    } else if (typeof data === 'object') {
      // Intentar extraer alguna propiedad común si existe
      const first = Object.values(data)[0] as any;
      if (first && typeof first === 'string') return first;
      if (first && typeof first === 'object' && first.message)
        return first.message;
      return 'Error inesperado';
    }
  }

  if (error?.message) {
    return error.message;
  }

  // ✅ Último recurso: mensaje genérico
  return 'Error inesperado';
}
